<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'

export default {
  components: {
    Label,
    AppDisplay
  },
  props: {
    cadastrante: {
      type: Object
    }
  },
  methods: {
    formataMunicipioUF (municipio) {
      if (!municipio.nome || !municipio.codigoEstado) return ''
      return `${municipio.nome}/${municipio.codigoEstado}`
    }
  }
}

</script>

<template>
  <div>
    <div>
      <span class="title-cadastrante">Dados do cadastrante</span>
      <hr />
    </div>
    <el-row>
      <el-col v-if="cadastrante.tipo === 'PF'" :span="12">
        <app-display label="Nome completo:" :content="cadastrante.pessoaFisica.nome" />
        <app-display label="CPF:" :content="cadastrante.pessoaFisica.cpf" />
      </el-col>
      <el-col v-else :span="12">
        <app-display label="Razão social:" :content="cadastrante.pessoaJuridica.razaoSocial" />
        <app-display label="Nome fantasia:" :content="cadastrante.pessoaJuridica.nomeFantasia" />
        <app-display label="CNPJ:" :content="cadastrante.pessoaJuridica.cnpj" />
      </el-col>
      <el-col :span="12">
        <app-display label="E-mail(s):" :content="cadastrante.emails.length ? cadastrante.emails.map(e => e.dado).join(', ') : null" />
        <app-display label="Telefone(s):" :content="cadastrante.telefones.length ? cadastrante.telefones.map(t => t.numero).join(', ') : null" />
      </el-col>
    </el-row>
    <div class="mt-2">
      <div>
        <span class="title-cadastrante">Endereço de correspondência</span>
        <hr />
      </div>
      <el-row>
        <el-col :span="12">
          <app-display label="CEP:" :content="cadastrante.enderecoCorrespondencia.cep" />
          <app-display label="Logradouro:" :content="cadastrante.enderecoCorrespondencia.logradouro" />
          <app-display label="Número:" :content="cadastrante.enderecoCorrespondencia.numero" />
        </el-col>
        <el-col :span="12">
          <app-display label="Complemento:" :content="cadastrante.enderecoCorrespondencia.complemento" />
          <app-display label="Bairro:" :content="cadastrante.enderecoCorrespondencia.bairro" />
          <app-display label="Município/UF:" :content="cadastrante.enderecoCorrespondencia.municipio ? formataMunicipioUF(cadastrante.enderecoCorrespondencia.municipio) : ''" />
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Cadastrante/Cadastrante.vue